module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.74f6918c.woff";